export const checkCircleExist = (circles, name) => {
  return circles.length > 0 && circles.some((circle) => circle.name === name);
};
